/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import BannersSlider from './banners-slider';

export default BannersSlider;



// WEBPACK FOOTER //
// ./src/containers/BannersSlider/index.js